module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"_untagged":"Other"},"de":{"POIs":"POIs","Routes":"Strecke","Areas":"Gebiete","Categories":"Kategorien","Tags":"Schlagworte","_untagged":"Weitere Kartenebenen"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./app/components/layerlist/LayerList.vue
// module id = 0VQP
// module chunks = 1